let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lRweH")).then(() => parcelRequire('9TNDT'));